import { render } from "./HelpRequestBtn.vue?vue&type=template&id=2f5176d0&scoped=true"
import script from "./HelpRequestBtn.vue?vue&type=script&lang=js"
export * from "./HelpRequestBtn.vue?vue&type=script&lang=js"

import "./HelpRequestBtn.vue?vue&type=style&index=0&id=2f5176d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5176d0"]])

export default __exports__